
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../Store';

import Footer from '../footer/Footer';
import styles from './landingpage.module.scss';

export default function LandingPageAnonymous() {

    //const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.authSlice.auth);

    useEffect(() => {
    }, [])


    return (
        <>
            <div className={styles.landingpageHeroContainer}>
                <h3 className={styles.landingpageHeroHeadline}>{t('deTranslation.landingPage.heroHeadline')}</h3>

                <h4 className={styles.heroText}>Einfach. Übersichtlich. Effizient.</h4>

                <h5 className={styles.heroText}>Die smarte Webanwendung für Handwerksbetriebe.</h5>

                <div className={styles.landingPageCardsContainer}>

                    <div></div>

                    <div className="card" style={{ padding: '4em', textShadow: '0 0 9px grey' }}>
                        Behalte jederzeit den Überblick über deine Aufträge - egal ob auf der Baustelle, im Büro oder unterwegs.
                    </div>

                    <div className="card" style={{ padding: '4em', textShadow: '0 0 9px grey' }}>
                        Erstelle, bearbeite und organisiere Kundenaufträge in Sekunden - ganz ohne Papierkram.
                    </div>

                    <div className="card" style={{ padding: '4em', textShadow: '0 0 9px grey' }}>
                        Weise Aufgaben direkt deinen Teams zu - transparent und zeitsparend.
                    </div>

                    <div></div>
                    <div></div>

                    <div className="card" style={{ padding: '4em', textShadow: '0 0 9px grey' }}>
                        Mitarbeiter effizient einteilen
                    </div>

                    <div className="card" style={{ padding: '4em', textShadow: '0 0 9px grey' }}>
                        Immer und überall verfügbar
                    </div>

                     <div className="card" style={{ padding: '4em', textShadow: '0 0 9px grey' }}>
                        Monatlich kündbar
                    </div>
                </div>

                <Footer />

            </div >
        </>
    );
}
